import { createLazyMemo } from '@solid-primitives/memo';

import { OddsSettings } from '../../types';
import { useBetSlipStore } from '../../useBetSlip';

// 赔率设置选项的标签配置
const ODDS_SETTINGS = () => [
  {
    label: t('Accept any odds changes'),
    optionLabel: t('Accept any odds changes'),
    value: OddsSettings.ACCEPT_ANY_ODDS_CHANGE,
  },
  {
    label: t('Accept higher odds only'),
    optionLabel: t('Accept higher odds only'),
    value: OddsSettings.ACCEPT_HIGHER_ODDS_CHANGE,
  },
  {
    label: t('Reject all odds changes'),
    optionLabel: t('Reject all odds changes'),
    value: OddsSettings.ACCEPT_NOTHING_ODDS_CHANGE,
  },
];

export const OddsSettingPage = () => {
  const [store, dispatch] = useBetSlipStore();

  const settings = ODDS_SETTINGS();

  const oddSetting = createLazyMemo(() => {
    return settings.find((v) => v.value === store.oddsSettings);
  });

  const showOddsSetting = createSignal(false);

  return (
    <Select
      bind={[
        () => oddSetting(),
        (setting) => {
          showOddsSetting[1](false);
          dispatch({
            type: 'SET_ODDS_SETTINGS',
            settings: setting.value,
          });
        },
      ]}
      type="secondary"
      options={settings}
      class="text-neutral-main2 caption-m-medium h-8"
      style={{ 'background-color': 'var(--bg-betslip-body-bg)' }}
    />
  );
};
